import { Injectable, inject } from "@angular/core";
import { NxDropdownIntl } from "@allianz/ng-aquila/dropdown";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class NxDropdownIntlProvider extends NxDropdownIntl {
  private translateService = inject(TranslateService);

  constructor() {
    super();
    this.selectAll = this.translateService.instant(
      "nx-dropdown-intl.selectAll"
    );
    this.clearAll = this.translateService.instant("nx-dropdown-intl.clearAll");
  }

  override selectAll: string;
  override clearAll: string;
}
